import './importance.css'
import React from 'react'
import TitleSection from '../TitleSection/TitleSection'
import img1 from '../img/Why/1.png'
import img2 from '../img/Why/2.png'
import img3 from '../img/Why/3.png'
import img4 from '../img/Why/4.png'
import img5 from '../img/Why/5.png'
import img6 from '../img/Why/6.png'
import { motion } from 'framer-motion'
import { useInView } from 'react-intersection-observer'

const ImportanceItem = ({ item, delay }) => {
  const [ref, inView] = useInView({ triggerOnce: true })

  return (
    <motion.div
      ref={ref}
      className='single-timeline mt-5'
      initial={{ opacity: 0, y: 50 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 1, delay }}
    >
      <div className='timeline-dot'></div>
      <div className='single-content'>
        <div className='inner'>
          <div className='row row--30 align-items-center'>
            <div className='col-lg-6 order-2 order-lg-1'>
              <div className='content'>
                <span>{item.span}</span>
                <h2 className='text-right'>{item.title}</h2>
                <p className='boxp'>{item.des1}</p>
                <p className='boxp'>{item.des2}</p>
              </div>
            </div>
            <div className='col-lg-6 order-1 order-lg-2'>
              <div className='thumbnail'>
                <img src={item.img} alt={item.title} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  )
}

function Importance() {
  const data = [
    {
      id: 1,
      span: "السبب الأول",
      title: 'زيادة التحويلات:',
      des1: "تشير إلى تحسين نسبة الزوار الذين يتخذون إجراءً معينًا (مثل الشراء، التسجيل، أو الاشتراك) بعد زيارة الموقع. المواقع الإلكترونية تُعتبر أداة فعّالة لتحقيق هذا الهدف بسبب تصميمها الموجه نحو تقديم معلومات مفيدة وجذابة، مما يجعلها أكثر فعالية.",
      des2: "باختصار، المواقع الإلكترونية تُعتبر أداة قوية لزيادة التحويلات بفضل تصميمها الموجه والتركيز الواضح على تقديم قيمة مضافة للزوار.",
      img: img1,
    },
    {
      id: 2,
      span: "السبب الثاني",
      title: 'تركيز الجهود التسويقية:',
      des1: "المواقع الإلكترونية تسمح لك بتركيز رسالتك التسويقية على مجموعة متنوعة من المنتجات أو الخدمات. هذا التنوع يجعل من السهل توجيه الزوار نحو اتخاذ قرارات الشراء أو التفاعل المطلوب.",
      des2: "إضافةً إلى ذلك، يمكن أن توفر المواقع الإلكترونية ميزة أخرى وهي التجزئة. يمكن للشركات إنشاء صفحات مخصصة لكل شريحة من الجمهور المستهدف، مع محتوى مخصص يتناسب مع اهتمامات واحتياجات تلك الشريحة. بهذه الطريقة، يتم تعزيز فعالية الرسائل التسويقية وجعلها أكثر ملاءمة للزوار المختلفين.",
      img: img2,
    },
    {
      id: 3,
      span: "السبب الثالث",
      title: 'تحليل الأداء:',
      des1: "باستخدام أدوات التحليل، يمكنك متابعة أداء المواقع الإلكترونية ومعرفة مصدر الزوار وسلوكهم. هذا يساعدك في تحسين استراتيجياتك التسويقية استنادًا إلى البيانات.",
      des2: "إضافةً إلى ذلك، توفر أدوات التحليل معلومات دقيقة حول تفاعل الزوار مع محتوى الموقع، مثل الأجزاء الأكثر مشاهدة أو الأزرار التي يتم النقر عليها بشكل متكرر. هذه المعلومات تمكنك من إجراء تعديلات مستنيرة على الموقع لتحسين تجربتهم وزيادة معدلات التحويل.",
      img: img3,
    },
    {
      id: 4,
      span: "السبب الرابع",
      title: 'زيادة معدل البقاء:',
      des1: "المواقع الإلكترونية المصممة جيدًا تزيد من احتمالية بقاء الزائر في موقعك لفترة أطول واستكشاف المزيد من المحتوى.",
      des2: "إضافةً إلى ذلك، تصميم الموقع بعناية يمكن أن يعزز تجربة المستخدم ويساعد في بناء علاقة أقوى مع الزوار. عندما يجد الزوار الموقع جذابًا وسهل الاستخدام، فإنهم يكونون أكثر عرضة للبقاء واستكشاف المزيد من الصفحات.",
      img: img4,
    },
    {
      id: 5,
      span: "السبب الخامس",
      title: 'تحسين محركات البحث (SEO):',
      des1: "المواقع الإلكترونية المصممة بشكل صحيح يمكن أن تساعد في تحسين ترتيب موقعك في محركات البحث، مما يزيد من الوصول إلى جمهور أوسع.",
      des2: "إضافةً إلى ذلك، عند تحسين الموقع لكلمات مفتاحية ذات صلة بمنتجك أو خدمتك، فإنك تزيد من احتمالية ظهوره في نتائج البحث عندما يبحث المستخدمون عن تلك الكلمات. هذا لا يساعد فقط في جذب المزيد من الزوار، بل يجذب أيضًا الزوار الذين لديهم اهتمام فعلي بما تقدمه، مما يزيد من جودة حركة المرور إلى موقعك.",
      img: img5,
    },
    {
      id: 6,
      span: "السبب السادس",
      title: 'تجربة المستخدم:',
      des1: "المواقع الإلكترونية المصممة بشكل جيد توفر تجربة مستخدم سلسة وسهلة الفهم، مما يعزز رضا العملاء وثقتهم في العلامة التجارية.",
      des2: "إضافةً إلى ذلك، تجربة المستخدم الجيدة تشمل أيضًا سرعة تحميل الموقع واستجابته على مختلف الأجهزة والشاشات. عندما يجد الزوار أن الموقع يستجيب بسرعة ويعرض المحتوى بشكل جيد على الهواتف المحمولة والأجهزة اللوحية، يزيد ذلك من رضاهم ويشجعهم على البقاء واستكشاف المزيد.",
      img: img6,
    },
  ]

  return (
    <div className='importance' id='importanceid'>
      <div className="container">
        <TitleSection title="لماذا المواقع الإلكترونية" />
        <p className='p-importance'>إن تصميم موقع ويب لمنتج أو خدمة معينة يمكن أن يكون له فوائد كبيرة للشركة. إليك بعض الأسباب التي تبرز أهمية المواقع الإلكترونية:</p>
        <div className="row">
          <div className="col-lg-12">
            <div className='rainbow-timeline-wrapper'>
              <div className="timeline-line"></div>
              {data.map((item, index) => (
                <ImportanceItem key={index} item={item} delay={index * 0.2} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Importance
